export default function TriangleForgeSeo() {
  return (
    <>
      <h2 style={{ color: "#E8E9F3", fontSize: 19, margin: "0 0 12px" }}>
        Named triangles — the geometry shortcut everyone needs
      </h2>
      <p style={{ margin: "0 0 16px" }}>
        Trigonometry students who do well share a habit: they recognize the
        special triangles by sight, instantly, without thinking. 30-60-90 with
        its 1, √3, 2 sides. 45-45-90 with its 1, 1, √2 sides. The golden
        gnomon with its 36-72-72 angles. These recurring triangles are not
        coincidences — they fall out of regular polygons, the unit circle,
        the golden ratio. Knowing them turns problems that would take
        minutes of trigonometry into one-line recognitions. Triangle Forge
        teaches you to build each named triangle by setting its angles or
        sides correctly, and the catalog is the whole point.
      </p>

      <h2 style={{ color: "#E8E9F3", fontSize: 19, margin: "24px 0 12px" }}>
        The ten triangles
      </h2>
      <p style={{ margin: "0 0 16px" }}>
        Equilateral (60-60-60). Right isoceles (45-45-90). The two 30-60-90
        orientations. The golden gnomon (36-72-72) and its dual the golden
        triangle (72-72-36) — both with sides in the golden ratio. The
        right triangle with sides 3-4-5, the smallest integer Pythagorean
        triple. The 5-12-13 triple. The 15-75-90 triangle which falls out
        of the 30-60-90 / 45-45-90 sum. And the regular pentagon's
        diagonal-triangle. Each one shows up in real math: in the unit
        circle, in regular polygons, in physics problems, in computer
        graphics. The game's catalog is verified — every named triangle
        in it matches its real-world definition exactly.
      </p>

      <h2 style={{ color: "#E8E9F3", fontSize: 19, margin: "24px 0 12px" }}>
        Why the golden gnomon matters
      </h2>
      <p style={{ margin: "0 0 16px" }}>
        The golden gnomon is the obscure-feeling one and the one most worth
        knowing. Its 36-72-72 angles appear in the regular pentagon, in the
        Penrose tiling, in the geometry of phyllotaxis (how plants arrange
        leaves on a stem to maximize sunlight). The ratio of its long side
        to its short side is exactly the golden ratio φ. Most students go
        through high school without ever meeting this triangle even though
        it's everywhere in nature. Triangle Forge makes it one of ten you
        can build, on equal footing with the famous ones.
      </p>
    </>
  );
}
